.container {
  padding: 10px 0;
  font-size: 0.7em;
}

.chart {
  height: 200px;
  flex: 1 1 90%;
  font-size: inherit;
  overflow: hidden;
  margin-left: -2.5em;
}

.xAxisLegend {
  margin-left: 5em;
}
